/* CT 2026-09-25 — RESEÑAS DE JUDGE.ME: ficha (#judgeme_product_reviews) y carrusel de la home (.jdgm-cards-carousel).
 * Estilos: ct-diseno.css. Corre al terminar de cargar la página, nunca en un toque (se mide el INP).
 * FICHA
 * (1) COMPACTO, referencia MercadoLibre: se ven las 3 primeras reseñas y un botón "Ver las N reseñas" que despliega el
 *     resto y la paginación de Judge.me. Con 3 o menos no hay botón.
 * (2) NOMBRE: "Diana Milena Diana Rojas" → "Diana R." (primer nombre e inicial del último apellido), y la inicial en el
 *     círculo gris cuando Judge.me no trae foto. Si en Judge.me se configura el formato de nombre, esto no cambia nada.
 * (1b) CT 2026-09-26: el mismo diseño sobre el WIDGET NUEVO de Judge.me (clases jm-*), que es el que se dibuja en los
 *     834 productos desde el 25-sep: ver montarNuevo(). El código de (1) y (2) queda para el clásico.
 * CARRUSEL DE LA HOME (Judge.me "Cards Carousel", el que eligió Camilo)
 * (3) Nombre corto, "Compra verificada" junto al tilde, promedio "4,6 · 2.520 reseñas" y etiquetas en español.
 *     El widget NO trae fecha ni respuestas de la tienda: no se inventan.
 */
(() => {
  const MAX = 3;
  // Promedio y total de TODAS las reseñas de la tienda (judgeme.all_reviews_rating / all_reviews_count), que el tema pone
  // en data-* de este mismo <script>. currentScript solo existe mientras el script corre: se lee acá arriba.
  const DATOS = (document.currentScript && document.currentScript.dataset) || {};
  const nombreCorto = (t) => {
    const p = (t || '').trim().split(/\s+/).filter(Boolean);
    if (p.length < 2) return (t || '').trim();
    const ult = p[p.length - 1];
    // Solo si el apellido empieza con letra: "Fundación 4 Vientos" o "Tienda 22" se dejan enteros.
    if (!/^\p{L}/u.test(ult)) return p.join(' ');
    return p[0] + ' ' + ult.charAt(0).toUpperCase() + '.';
  };
  const inicial = (t) => ((t || '').trim().charAt(0) || '').toUpperCase();

  // ---------------- FICHA ----------------
  const vestir = (raiz) => {
    raiz.querySelectorAll('.jdgm-rev').forEach((rev) => {
      if (rev.dataset.ctVestida) return;
      rev.dataset.ctVestida = '1';
      const a = rev.querySelector('.jdgm-rev__author');
      if (a) a.textContent = nombreCorto(a.textContent);
      const ic = rev.querySelector('.jdgm-rev__icon');
      if (ic && !ic.querySelector('img') && !ic.textContent.trim() && a) ic.textContent = inicial(a.textContent);
    });
  };
  const montar = (w) => {
    const widg = w.querySelector('.jdgm-rev-widg');
    const lista = w.querySelector('.jdgm-rev-widg__reviews');
    if (!widg || !lista) return false;
    vestir(lista);
    // Promedio con coma decimal, como el resto de la tienda ("4,67 de 5").
    const prom = w.querySelector('.jdgm-rev-widg__summary-average a');
    if (prom) prom.textContent = prom.textContent.replace(/(\d)\.(\d)/, '$1,$2');
    // La paginación de Judge.me puede reemplazar el contenedor de reseñas entero: se observa el cuerpo del widget.
    const cuerpo = w.querySelector('.jdgm-rev-widg__body') || lista;
    if ('MutationObserver' in window) new MutationObserver(() => vestir(cuerpo)).observe(cuerpo, { childList: true, subtree: true });
    if (widg.dataset.ctCompacto) return true;
    widg.dataset.ctCompacto = '1';
    const n = lista.querySelectorAll('.jdgm-rev').length;
    const pag = w.querySelector('.jdgm-paginate');
    const hayMas = n > MAX || (pag && pag.querySelector('.jdgm-paginate__page, .jdgm-paginate__next-page'));
    if (!hayMas) return true;
    const total = ((w.querySelector('.jdgm-rev-widg__summary-text') || {}).textContent || '').match(/\d+/);
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'button button--secondary ct-resenas__ver-todas';
    b.textContent = total ? `Ver las ${total[0]} reseñas` : 'Ver todas las reseñas';
    b.addEventListener('click', () => { widg.classList.remove('ct-resenas--compacto'); b.remove(); });
    widg.classList.add('ct-resenas--compacto');
    (pag || lista).insertAdjacentElement('afterend', b);
    return true;
  };

  // ---------------- CARRUSEL DE LA HOME (Judge.me "Cards Carousel") ----------------
  // Lo que el bloque no ofrece: promedio con coma y total con punto de miles, nombre corto, "Compra verificada" en texto
  // junto al tilde (Judge.me lo pone SOLO en reseñas de compradores: medido, "Maria" sin compra no lo tiene), y las
  // etiquetas en inglés que leen los lectores de pantalla.
  const vestirTarjetas = (raiz) => {
    raiz.querySelectorAll('.jdgm-card').forEach((c) => {
      if (c.dataset.ctVestida) return;
      c.dataset.ctVestida = '1';
      const nom = c.querySelector('.jdgm-reviewer-name');
      if (nom) nom.textContent = nombreCorto(nom.textContent);
      const tilde = c.querySelector('.jdgm-reviewer-verified-icon');
      if (tilde && !c.querySelector('.ct-cards__verificada')) {
        const v = document.createElement('span');
        v.className = 'ct-cards__verificada';
        v.textContent = 'Compra verificada';
        tilde.insertAdjacentElement('afterend', v);
      }
      c.querySelectorAll('img[alt="Review Image"]').forEach((im) => im.setAttribute('alt', 'Foto de la reseña'));
    });
  };
  const vestirCarrusel = (w) => {
    if (!w.querySelector('.jdgm-card')) return false;
    vestirTarjetas(w);
    // El carrusel puede agregar tarjetas al desplazarse: se vuelven a vestir.
    if ('MutationObserver' in window) new MutationObserver(() => vestirTarjetas(w)).observe(w, { childList: true, subtree: true });
    const txt = w.querySelector('.jdgm-rating-text');
    const prom = parseFloat(DATOS.ctProm) || parseFloat(txt && txt.textContent);
    const total = parseInt(DATOS.ctTotal, 10) || parseInt(((w.querySelector('.jdgm-reviews-count') || {}).textContent || ''), 10);
    if (txt && prom > 0 && total > 0) {
      txt.textContent = '';
      const a = document.createElement('span'); a.className = 'ct-cards__prom'; a.textContent = prom.toFixed(1).replace('.', ',');
      const b = document.createElement('span'); b.className = 'ct-cards__total'; b.textContent = ` · ${total.toLocaleString('es-CO')} reseñas`;
      txt.append(a, b);
    }
    const est = w.querySelector('.jdgm-average-rating .jdgm-stars');
    if (est && prom > 0) est.setAttribute('aria-label', `${prom.toFixed(1).replace('.', ',')} de 5 estrellas`);
    const flechas = w.querySelectorAll('button.jdgm-arrow');
    if (flechas[0]) flechas[0].setAttribute('aria-label', 'Reseñas anteriores');
    if (flechas[1]) flechas[1].setAttribute('aria-label', 'Reseñas siguientes');
    w.classList.add('ct-cards--listo');
    return true;
  };

  // ---------------- FICHA, WIDGET NUEVO DE JUDGE.ME (clases jm-*) ----------------
  // CT 2026-09-26. Entre el 25-sep 17:13 y 20:00 (Bogotá) Judge.me escribió en los 834 productos publicados el dato de su
  // widget nuevo (metafield judgeme.review_widget_data) y su cargador pasó a dibujar ese widget en vez del clásico: el
  // diseño de arriba (montar) dejó de aplicar producto por producto. El clásico deja de publicarse el 9-oct.
  // El widget nuevo es una app de Vue montada DENTRO de #judgeme_product_reviews. Para no pelear con Vue:
  //   · el resumen (promedio, estrellas y barras) y el botón "Ver las N reseñas" son HERMANOS de la app, no hijos;
  //   · el nombre corto se escribe sobre el nodo de texto que ya existe (Vue lo vuelve a poner al paginar y el
  //     observador lo acorta otra vez);
  //   · todo lo demás es CSS (ct-diseno.css, bloque "RESEÑAS DE LA FICHA — WIDGET NUEVO").
  // Los datos salen de window.jdgm.data.reviewWidget[<id>], que el mismo bloque de Judge.me imprime en la página.
  const SVG = 'http://www.w3.org/2000/svg';
  const RUTA_ESTRELLA = 'M10 1.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L10 14.9l-5.2 2.8 1-5.9L1.5 7.7l5.9-.8z';
  const estrella = (llena) => {
    const s = document.createElementNS(SVG, 'svg');
    s.setAttribute('viewBox', '0 0 20 20');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('class', 'ct-res-estrella' + (llena ? '' : ' ct-res-estrella--vacia'));
    const p = document.createElementNS(SVG, 'path');
    p.setAttribute('d', RUTA_ESTRELLA);
    s.appendChild(p);
    return s;
  };
  const fila5 = (llenas) => {
    const f = document.createElement('span');
    f.className = 'ct-res-estrellas';
    for (let i = 0; i < 5; i++) f.appendChild(estrella(i < llenas));
    return f;
  };
  const coma = (n, dec) => n.toFixed(dec).replace('.', ',');
  const el = (tag, cls, txt) => { const e = document.createElement(tag); e.className = cls; if (txt != null) e.textContent = txt; return e; };

  const resumenNuevo = (datos, titulo) => {
    const prom = parseFloat(datos.average_rating) || 0, n = datos.number_of_reviews;
    const r = el('div', 'ct-res-resumen');
    r.appendChild(el('h2', 'ct-res-titulo', titulo || 'Reseñas de Clientes'));
    const fila = el('div', 'ct-res-fila');
    const izq = el('div', 'ct-res-prom');
    izq.appendChild(el('div', 'ct-res-num', `${coma(prom, 2)} de 5`));
    // Estrellas del promedio: vacías debajo y llenas encima, recortadas al porcentaje.
    const est = el('span', 'ct-res-promedio-estrellas');
    est.setAttribute('role', 'img');
    est.setAttribute('aria-label', `${coma(prom, 2)} de 5 estrellas`);
    const llenas = fila5(5);
    llenas.classList.add('ct-res-estrellas--llenas');
    llenas.style.width = `${Math.max(0, Math.min(100, prom / 5 * 100))}%`;
    est.append(fila5(0), llenas);
    izq.appendChild(est);
    izq.appendChild(el('div', 'ct-res-basado', `Basado en ${n.toLocaleString('es-CO')} ${n === 1 ? 'reseña' : 'reseñas'}`));
    fila.appendChild(izq);
    const barras = el('div', 'ct-res-barras');
    [5, 4, 3, 2, 1].forEach((k) => {
      const h = (datos.histogram || []).find((x) => +x.rating === k) || { frequency: 0, percentage: 0 };
      const b = el('div', 'ct-res-barra-fila');
      const e = fila5(k);
      e.setAttribute('role', 'img');
      e.setAttribute('aria-label', `${k} ${k === 1 ? 'estrella' : 'estrellas'}`);
      const barra = el('span', 'ct-res-barra');
      const lleno = el('span', 'ct-res-barra__lleno');
      lleno.style.width = `${+h.percentage || 0}%`;
      barra.appendChild(lleno);
      b.append(e, barra, el('span', 'ct-res-barra-n', String(h.frequency || 0)));
      barras.appendChild(b);
    });
    fila.appendChild(barras);
    r.appendChild(fila);
    return r;
  };
  const vestirNuevo = (w) => {
    w.querySelectorAll('.jm-reviewer-info__name').forEach((a) => {
      const t = a.firstChild && a.firstChild.nodeType === 3 ? a.firstChild : null;
      if (!t) return;
      const corto = nombreCorto(t.nodeValue);
      if (corto && corto !== t.nodeValue.trim()) t.nodeValue = corto;
    });
  };
  const montarNuevo = (w) => {
    const app = w.querySelector('.jm-review-widget');
    if (!app) return false;
    const datos = ((window.jdgm || {}).data || {}).reviewWidget && window.jdgm.data.reviewWidget[w.dataset.productId];
    vestirNuevo(w);
    if (!app.dataset.ctObservada) {
      app.dataset.ctObservada = '1';
      // Nombres cortos también en las páginas siguientes (Vue reescribe el texto al paginar).
      if ('MutationObserver' in window) new MutationObserver(() => vestirNuevo(w)).observe(app, { childList: true, subtree: true, characterData: true });
    }
    const n = datos ? datos.number_of_reviews : 0;
    const tit = ((w.querySelector('.jm-review-widget-minimal-header__title') || {}).textContent || '').trim();
    if (n > 0 && !w.querySelector(':scope > .ct-res-resumen')) {
      w.insertBefore(resumenNuevo(datos, tit), w.firstChild);
      w.dataset.ctResumen = '1';
    }
    // Sin reseñas: el mismo título y el mismo mensaje que muestra Judge.me ("Este producto no ha recibido ninguna reseña
    // todavía"), con el estilo de la ficha. Nada de "0 de 5" ni barras en cero.
    // CT 2026-09-26: en la plantilla no-tenemos (bajo pedido) sin reseñas no va NADA, ni título ni mensaje (Camilo): sin
    // resumen, el CSS oculta la sección entera.
    const vacio = w.querySelector('.jm-no-reviews-state__text');
    const bajoPedido = document.body.classList.contains('ct-tpl-product--no-tenemos');
    // CT 2026-09-26 (Camilo): sin reseñas no va NADA en ninguna plantilla; el CSS oculta la sección entera. Se deja el
    // bloque por si se quiere volver a mostrar el mensaje: bastaría con quitar 'false &&'.
    if (false && datos && n === 0 && vacio && !bajoPedido && !w.querySelector(':scope > .ct-res-resumen')) {
      const r = el('div', 'ct-res-resumen ct-res-resumen--vacio');
      r.append(el('h2', 'ct-res-titulo', tit || 'Reseñas de Clientes'), el('p', 'ct-res-vacio', vacio.textContent.trim()));
      w.insertBefore(r, w.firstChild);
      w.dataset.ctResumen = '1';
    }
    if (n > MAX && !w.dataset.ctAbierto && !w.querySelector(':scope > .ct-resenas__ver-todas')) {
      w.dataset.ctCompacto = '1';
      const b = el('button', 'button button--secondary ct-resenas__ver-todas', `Ver las ${n.toLocaleString('es-CO')} reseñas`);
      b.type = 'button';
      b.addEventListener('click', () => { delete w.dataset.ctCompacto; w.dataset.ctAbierto = '1'; b.remove(); });
      w.appendChild(b);
    }
    return true;
  };
  // El widget nuevo puede armarse tarde (Judge.me lo carga al acercarse a la vista): se observa el contenedor sin
  // límite de tiempo, y si Vue lo vuelve a montar (desaparecen el resumen o el botón) se ponen otra vez.
  const vigilarNuevo = (w) => {
    if (w.dataset.ctVigilado) return;
    w.dataset.ctVigilado = '1';
    let cola = false;
    const probar = () => { cola = false; montarNuevo(w); };
    probar();
    if ('MutationObserver' in window) new MutationObserver(() => { if (!cola) { cola = true; requestAnimationFrame(probar); } }).observe(w, { childList: true });
  };

  const intentar = (vuelta) => {
    let pendiente = false;
    const w = document.getElementById('judgeme_product_reviews');
    // Cada parte se monta UNA vez (montar() engancha un observador: no se repite en los reintentos).
    // Widget nuevo (jm-*): se vigila aparte y sin límite de tiempo (Judge.me puede armarlo tarde).
    if (w) vigilarNuevo(w);
    const nuevo = w && (w.classList.contains('jdgm-widget-revamp') || w.querySelector('.jm-review-widget'));
    if (w && !nuevo && !w.dataset.ctListo) { if (w.classList.contains('jdgm--done-setup-widget') && montar(w)) w.dataset.ctListo = '1'; else pendiente = true; }
    const car = document.querySelector('.jdgm-cards-carousel');
    if (car && !car.classList.contains('ct-cards--listo') && !vestirCarrusel(car)) pendiente = true;
    if (pendiente && vuelta < 40) setTimeout(() => intentar(vuelta + 1), 500);
  };
  const empezar = () => intentar(0);
  if (document.readyState === 'complete') empezar(); else window.addEventListener('load', empezar);
})();

// ---------------- FORMULARIO DE RESEÑA AL LLEGAR DESDE EL CORREO ----------------
// CT 2026-09-30. El enlace de una estrella del correo de Judge.me trae ?judgeme_token=… y Judge.me llena el correo y el
// nombre del cliente con ese token. En el formulario COMPACTO (una sola pantalla) esos dos campos igual se ven, ya llenos,
// y alargan el formulario: si los dos traen valor, se esconden y queda "Publicas como Camilo R. · Cambiar".
// En el formulario de varios pasos no se toca nada (esconderlos dejaría una pantalla vacía).
//
// CT 2026-09-30 (2.ª versión) — BUG: "Enviar Reseña" de la reseña de la TIENDA (el 2.º formulario) no enviaba al primer
// toque. Medido: si correo o nombre quedan VACÍOS mientras están escondidos, Judge.me marca el error en un campo que nadie
// ve y el botón parece muerto (6 toques, 0 envíos). La 1.ª versión escondía una sola vez y no volvía a mirar. Ahora:
//   · se revisa mientras el formulario está abierto: escondidos SOLO si los dos tienen valor; si alguno se vacía, se muestran;
//   · al tocar "Enviar", ANTES de que Judge.me valide (fase de captura), si falta alguno se muestran, así el error se ve;
//   · CT 2026-09-30 (3.ª versión, Camilo vio los campos abiertos en PC): la 2.ª dejaba los campos a la vista PARA SIEMPRE
//     en cuanto un dato faltaba un instante (Judge.me reescribe el nombre mientras carga: se vio "Camilorozo"), y según el
//     momento quedaban abiertos. Ahora son tres estados: "escondidos"; "visibles" (faltaba un dato: si los dos vuelven a
//     tener valor y el cliente no los tocó, se esconden otra vez) y "cambiados" (el cliente tocó "Cambiar" o escribió en
//     ellos: quedan a la vista en esa visita).
(function () {
  if (!/[?&]judgeme_token=/.test(location.search)) return;
  const compacto = () => (window.jdgmSettings || {}).review_form_theme === 'compact';
  const campos = (m) => ({ mail: m.querySelector('input[name="reviewer_email"]'), nom: m.querySelector('input[name="reviewer_name"]') });
  const grupo = (x) => x.closest('.jdgm-write-review-modal__field-group') || x.parentElement;
  const llenos = ({ mail, nom }) => !!(mail && nom && mail.value.trim() && nom.value.trim());
  const mostrar = (m, estado) => {
    const c = campos(m);
    [c.mail, c.nom].filter(Boolean).forEach((x) => { grupo(x).style.display = ''; });
    m.querySelectorAll('.ct-resena-como').forEach((l) => l.remove());
    m.dataset.ctDatos = estado;
  };
  const esconder = (m, c) => {
    const p = c.nom.value.trim().split(/\s+/);
    const corto = p.length > 1 && /^[A-Za-zÁÉÍÓÚÑáéíóúñ]/.test(p[1]) ? `${p[0]} ${p[1][0].toUpperCase()}.` : c.nom.value.trim();
    const linea = document.createElement('p');
    linea.className = 'ct-resena-como';
    linea.append('Publicas como ');
    const b = document.createElement('strong'); b.textContent = corto; linea.append(b, ' · ');
    const cambiar = document.createElement('button'); cambiar.type = 'button'; cambiar.className = 'ct-resena-como__cambiar'; cambiar.textContent = 'Cambiar';
    cambiar.addEventListener('click', () => { mostrar(m, 'cambiados'); c.nom.focus(); });
    linea.append(cambiar);
    const g = [c.mail, c.nom].map(grupo);
    g.forEach((x) => { x.style.display = 'none'; });
    g[0].parentElement.insertBefore(linea, g[0]);
    m.dataset.ctDatos = 'escondidos';
  };
  const revisar = () => {
    const m = document.querySelector('.jdgm-write-review-modal');
    if (!m) return;
    if (!compacto()) { m.dataset.ctDatos = 'varios-pasos'; return; }
    if (m.dataset.ctDatos === 'cambiados') return;
    const c = campos(m);
    if (!c.mail || !c.nom) return;
    if (!llenos(c)) { if (m.dataset.ctDatos === 'escondidos') mostrar(m, 'visibles'); return; }
    // Los dos tienen valor: se esconden, salvo que el cliente esté escribiendo en ellos.
    if (document.activeElement === c.mail || document.activeElement === c.nom) return;
    if (m.dataset.ctDatos !== 'escondidos' || !m.querySelector('.ct-resena-como')) esconder(m, c);
  };
  // Judge.me llena los campos por código (propiedad value, no atributo): se revisa cada 300 ms mientras dure la visita
  // (tope 15 minutos). Es un querySelector: no pesa.
  let n = 0;
  const t = setInterval(() => { revisar(); if (++n > 3000) clearInterval(t); }, 300);
  document.addEventListener('click', (e) => {
    const btn = e.target && e.target.closest && e.target.closest('.jdgm-write-review-modal__nav-btn-next');
    if (!btn) return;
    const m = btn.closest('.jdgm-write-review-modal');
    if (m && !llenos(campos(m))) mostrar(m, 'visibles');
  }, true);
  // Si el cliente escribe en el correo o el nombre (a la vista), son suyos: ya no se esconden en esta visita.
  document.addEventListener('input', (e) => {
    if (!e.isTrusted || !e.target || !/^reviewer_(email|name)$/.test(e.target.name || '')) return;
    const m = e.target.closest('.jdgm-write-review-modal');
    if (m && m.dataset.ctDatos !== 'escondidos') m.dataset.ctDatos = 'cambiados';
  }, true);
})();

// ---------------- PANTALLA "¡GRACIAS POR TU RESEÑA!" ----------------
// CT 2026-09-30 (Camilo). Es la última pantalla del recorrido (la reseña de la tienda está apagada en Judge.me). Además de
// "Cerrar", un "Seguir comprando" que lleva al catálogo de telas. No se cierra sola: la decide el cliente (medido: Judge.me
// no la cierra; sigue abierta a los 90 s). La tarjeta compacta es CSS (ct-diseno.css).
// Solo se activa después de tocar "Enviar Reseña" (fase de captura) y busca la pantalla hasta 60 s: no corre en ninguna
// otra visita.
(function () {
  const CATALOGO = '/collections/catalogo-de-telas-textiles-tejidos';
  const poner = () => {
    const nav = document.querySelector('.jdgm-write-review-modal__page--thank-you.current-page .jdgm-write-review-modal__thank-you-nav');
    if (!nav) return false;
    if (nav.querySelector('.ct-gracias-seguir')) return true;
    const a = document.createElement('a');
    a.className = 'jdgm-write-review-modal__nav-btn ct-gracias-seguir';
    a.href = CATALOGO;
    a.textContent = 'Seguir comprando';
    nav.insertBefore(a, nav.firstChild);
    nav.classList.add('ct-gracias-nav');
    return true;
  };
  document.addEventListener('click', (e) => {
    if (!(e.target && e.target.closest && e.target.closest('.jdgm-write-review-modal__nav-btn-next'))) return;
    let n = 0;
    // Se sigue mirando el minuto completo: si Judge.me vuelve a dibujar la pantalla, el botón se repone.
    const t = setInterval(() => { poner(); if (++n > 200) clearInterval(t); }, 300);
  }, true);
})();

// ---------------- "ENVIAR RESEÑA": MENSAJE SI FALLA Y TOQUE QUE NO SE PIERDE ----------------
// CT 2026-09-30 (Camilo: en el celular tenía que tocar "Enviar Reseña" ~4 veces). Dos causas, las dos reproducidas en la
// tienda real con respuestas simuladas (nada se envió):
//  1) Si Judge.me RECHAZA el envío (p. ej. un enlace del correo que ya se usó) o se corta la conexión, su formulario compacto
//     no muestra NADA: escribe "Compact submit failed" en la consola y vuelve a habilitar el botón (leído en su código:
//     _compactSubmit → catch → _setSubmissionLoadingState(false)). Cada toque reintenta en silencio. Ahora aparece un
//     mensaje encima de los botones, según el error.
//  2) Con el teclado abierto, el botón está más arriba (y=432 en un 375×812). El toque cierra el teclado, la pantalla crece,
//     el botón baja (y=768) y el toque ya no cae en él: 0 envíos. Ahora un toque que EMPIEZA y TERMINA sobre "Enviar"
//     (sin arrastrar) dispara el envío aunque el botón se haya movido. Si el clic normal llegó, no se repite.
(function () {
  const BTN = '.jdgm-write-review-modal__nav-btn-next';
  const ENVIO = /\/api\/v1\/reviews(\?|$)|\/reviews\/update_review/;
  // 1) mensaje de error
  const mensaje = (texto) => {
    const m = document.querySelector('.jdgm-write-review-modal');
    if (!m) return;
    let el = m.querySelector('.ct-envio-error');
    if (!texto) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.className = 'ct-envio-error';
      el.setAttribute('role', 'alert');
      const nav = [...m.querySelectorAll('.jdgm-write-review-modal__navigation')].find((x) => x.offsetParent) || m.querySelector('.jdgm-write-review-modal__navigation');
      if (!nav) return;
      nav.parentElement.insertBefore(el, nav);
    }
    el.textContent = texto;
  };
  const textoError = (xhr) => {
    const s = xhr ? xhr.status : 0;
    const cuerpo = String((xhr && xhr.responseText) || '').toLowerCase();
    if (!s) return 'No pudimos enviar tu reseña: revisa tu conexión e inténtalo de nuevo.';
    if (/already|exist|duplicate|ya /.test(cuerpo)) return 'Ya calificaste este producto con este enlace. ¡Gracias! No hace falta enviarla de nuevo.';
    if (s >= 400 && s < 500) return 'No pudimos enviar tu reseña. Si ya la habías enviado con este mismo enlace, ya quedó registrada y no hace falta repetirla.';
    return 'El servicio de reseñas no respondió. Inténtalo de nuevo en unos minutos.';
  };
  let n = 0;
  const conectar = () => {
    const $ = window.jdgm && window.jdgm.$;
    if (!$ || typeof $ !== 'function' || !$.fn) return false;
    $(document).on('ajaxError', (ev, xhr, opts) => { if (opts && ENVIO.test(opts.url || '') && /post/i.test(opts.type || opts.method || '')) mensaje(textoError(xhr)); });
    $(document).on('ajaxSend', (ev, xhr, opts) => { if (opts && ENVIO.test(opts.url || '') && /post/i.test(opts.type || opts.method || '')) mensaje(''); });
    return true;
  };
  const t = setInterval(() => { if (conectar() || ++n > 200) clearInterval(t); }, 300);

  // 2) toque que no se pierde cuando el teclado se cierra
  let inicio = null;
  document.addEventListener('pointerdown', (e) => {
    const btn = e.target && e.target.closest && e.target.closest(BTN);
    inicio = btn && e.pointerType !== 'mouse' ? { btn, x: e.clientX, y: e.clientY, t: Date.now(), id: e.pointerId } : null;
  }, true);
  document.addEventListener('pointerup', (e) => {
    const s = inicio;
    inicio = null;
    if (!s || e.pointerId !== s.id) return;
    if (Math.hypot(e.clientX - s.x, e.clientY - s.y) > 12 || Date.now() - s.t > 800) return; // fue un arrastre, no un toque
    let llego = false;
    const oir = (ev) => { if (ev.target && ev.target.closest && ev.target.closest(BTN) === s.btn) llego = true; };
    document.addEventListener('click', oir, true);
    setTimeout(() => {
      document.removeEventListener('click', oir, true);
      if (!llego && s.btn.isConnected && !s.btn.disabled) s.btn.click();
    }, 350);
  }, true);
})();
